import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye, Trash2, PenLine, Info, Archive, ArchiveRestore } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import {
  DeleteConfirmDialog,
  VariantDialog,
  IngredientsDialog,
  AddOns,
  AllergenDialog,
  DetailsDialog,
  ArchiveConfirmDialog,
} from "@/components/dialog/common-dialog";
import { toast } from "react-hot-toast";
import {
  deleteDessertById,
  clearDessertMessages,
  updateExistingDessert,
  fetchAllDesserts,
} from "@/redux/slice/menu-manage-slice/dessert-slice";
import { useDispatch, useSelector } from "react-redux";
import hasPermission from "@/hooks/hasPermission";
import { Switch } from "@/components/ui/switch";
import { toggleItemStatus } from "@/api/new-api/staff-management/menu-manage/toggle-status";
import useAuth from "@/hooks/useAuth";

function DessertListTable({ dessert }) {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [archiveDialog, setArchiveDialog] = useState(false);
  const [archiveActionType, setArchiveActionType] = useState("archive");
  const [itemsDialog, setItemsDialog] = useState(null);
  const [variantDetails, setVarianDetails] = useState(false);
  const [ingredientsDialog, setIngredientsDialog] = useState(false);
  const [addOnsDialog, setAddOnsDialog] = useState(false);
  const [allergenDialog, setAllergenDialog] = useState(false);
  const [vodkaDetailsDialog, setVodkaDetailsDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);

  const { deleteLoading, updateLoading, requestStatus, error } = useSelector(
    (state) => state.menuManage.dessert
  );

  const closeArchiveDialog = () => {
    setArchiveDialog(false);
    setItemsDialog(null);
  };
  const closeVarintDetails = () => {
    setVarianDetails(false);
    setItemsDialog(null);
  };
  const colseIngredients = () => {
    setIngredientsDialog(false);
    setItemsDialog(null);
  };
  const closeAddOns = () => {
    setAddOnsDialog(false);
    setItemsDialog(null);
  };
  const closeAllergen = () => {
    setAllergenDialog(false);
    setItemsDialog(null);
  };
  const closeVodkaDetails = () => {
    setVodkaDetailsDialog(false);
    setItemsDialog(null);
  };

  const archiveHandler = async (id, item, type) => {
    try {
      if (!id) {
        toast.error("ID is required.");
        return;
      }
      dispatch(clearDessertMessages());
      const newStatus = type === "archive" ? "archived" : "active";
      const res = await dispatch(
        updateExistingDessert({
          id,
          data: {
            ...item,
            status: newStatus,
          },
        })
      );
      if (updateExistingDessert.fulfilled.match(res)) {
        toast.success(`Dessert archived successfully!`);
      } else if (updateExistingDessert.rejected.match(res)) {
        toast.error(res?.payload || `Failed to archive dessert.`);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
    } finally {
      closeArchiveDialog();
    }
  };

  const deleteHandler = async (id) => {
    try {
      if (!id) {
        toast.error("ID is required.");
        return;
      }
      dispatch(clearDessertMessages());
      const res = await dispatch(deleteDessertById(id));
      if (deleteDessertById.fulfilled.match(res)) {
        toast.success(`Dessert deleted successfully!`);
      } else if (deleteDessertById.rejected.match(res)) {
        toast.error(res?.payload || `Failed to delete dessert.`);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
    } finally {
      setDeleteDialog(false);
      setItemsDialog(null);
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const res = await toggleItemStatus("desserts", id);
      if (res.status === "success") {
        toast.success(res.message || "Dessert status updated successfully");
        dispatch(fetchAllDesserts(user?.restaurant_id));
      } else {
        toast.error(res.message || "Failed to toggle dessert status.");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
    }
  };

  return (
    <>
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[100px]">Item No</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Variant</TableHead>
            <TableHead>Ingredients</TableHead>
            <TableHead>Add-ons</TableHead>
            <TableHead>Allergen</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {dessert && dessert?.length > 0 ? (
            dessert?.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">
                  {item?.item_no || "N/A"}
                </TableCell>
                <TableCell>{item?.name}</TableCell>
                <TableCell>
                  <span className="flex gap-1 items-center cursor-pointer">
                    {" "}
                    {item?.variants_count}
                    <Eye
                      onClick={() => {
                        setVarianDetails(true);
                        setItemsDialog(item);
                      }}
                      size={18}
                    />
                  </span>
                </TableCell>
                <TableCell>
                  <span className="flex items-center gap-1 cursor-pointer">
                    {item?.ingredients_count}
                    <Eye
                      onClick={() => {
                        setIngredientsDialog(true);
                        setItemsDialog(item);
                      }}
                      size={18}
                    />
                  </span>
                </TableCell>
                <TableCell>
                  <span className="flex items-center gap-1 cursor-pointer">
                    {item?.add_ons_count}
                    <Eye
                      onClick={() => {
                        setAddOnsDialog(true);
                        setItemsDialog(item);
                      }}
                      size={18}
                    />
                  </span>
                  {/* dialog */}
                </TableCell>
                <TableCell>
                  <span className="flex items-center gap-1 cursor-pointer">
                    {" "}
                    {item?.allergens_count}
                    <Eye
                      onClick={() => {
                        setAllergenDialog(true);
                        setItemsDialog(item);
                      }}
                      size={18}
                    />
                  </span>
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    {item?.status === "active" ? (
                      <>
                        <span className="text-cgreen text-base">Active</span>
                        <Switch
                          checked={true}
                          onCheckedChange={() => handleToggleStatus(item.id)}
                        />
                      </>
                    ) : item?.status === "inactive" ? (
                      <>
                        <span className="text-cred text-base">Inactive</span>
                        <Switch
                          checked={false}
                          onCheckedChange={() => handleToggleStatus(item.id)}
                        />
                      </>
                    ) : item?.status === "archived" ? (
                      <span className="text-cred text-base">Archived</span>
                    ) : (
                      <span className="text-cred text-base">Draft</span>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-right justify-end flex gap-2 items-center">
                  <div className="flex items-center gap-2 h-8">
                    <Info
                      onClick={() => {
                        setVodkaDetailsDialog(true);
                        setItemsDialog(item);
                      }}
                      className="text-cwhite3 cursor-pointer"
                      size={18}
                    />

                    {hasPermission("back_office.menu_management.update_dessert") && item?.status !== "archived" && (
                      <Link
                        to={"/backoffice/menu/dessert/update"}
                        state={item}
                        className="cursor-pointer"
                      >
                        <PenLine className="text-cyellow" size={18} />
                      </Link>
                    )}

                    {hasPermission("back_office.menu_management.delete_dessert") && item?.status !== "archived" && (
                      <span>
                        {item?.status === "draft" ? (
                          <Trash2
                            onClick={() => {
                              setItemsDialog(item);
                              setDeleteDialog(true);
                            }}
                            className="text-cred cursor-pointer"
                            size={18}
                          />
                        ) : (
                          <Archive
                            onClick={() => {
                              setArchiveActionType("archive");
                              setItemsDialog(item);
                              setArchiveDialog(true);
                            }}
                            className="text-cred cursor-pointer"
                            size={18}
                          />
                        )}
                      </span>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={8} className="text-center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {/* dialog */}
      <VariantDialog
        items={itemsDialog}
        isOpen={variantDetails}
        onClose={closeVarintDetails}
      />
      <IngredientsDialog
        items={itemsDialog}
        isOpen={ingredientsDialog}
        onClose={colseIngredients}
      />
      <AddOns items={itemsDialog} isOpen={addOnsDialog} onClose={closeAddOns} />
      <AllergenDialog
        items={itemsDialog}
        isOpen={allergenDialog}
        onClose={closeAllergen}
      />
      <DetailsDialog
        items={itemsDialog}
        isOpen={vodkaDetailsDialog}
        onClose={closeVodkaDetails}
      />
      <ArchiveConfirmDialog
        isLoading={updateLoading}
        isOpen={archiveDialog}
        onClose={closeArchiveDialog}
        onConfirm={() => {
          archiveHandler(itemsDialog.id, itemsDialog, archiveActionType);
        }}
        title={archiveActionType === "archive" ? "Archive Dessert?" : "Restore Dessert?"}
        description={
          archiveActionType === "archive"
            ? `Are you sure you want to archive "${itemsDialog?.name}"?`
            : `Are you sure you want to restore "${itemsDialog?.name}"?`
        }
        isArchive={archiveActionType === "archive"}
      />
      <DeleteConfirmDialog
        isLoading={deleteLoading}
        isOpen={deleteDialog}
        onClose={() => {
          setDeleteDialog(false);
          setItemsDialog(null);
        }}
        onConfirm={() => {
          deleteHandler(itemsDialog.id);
        }}
        title="Delete Draft Dessert?"
        description={`Are you sure you want to delete the draft dessert "${itemsDialog?.name}"? This action cannot be undone.`}
      />
    </>
  );
}

export default DessertListTable;
